import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewChildren,
  AfterContentChecked,
  Output,
  EventEmitter,
  Input,
} from '@angular/core'
import { TabComponent } from './tab/tab.component'

@Component({
  selector: 'app-tabset',
  templateUrl: './tabset.component.html',
  styleUrls: ['./tabset.component.css'],
})
export class TabsetComponent implements AfterContentChecked {
  @ContentChildren(TabComponent) public tabs: QueryList<TabComponent>

  selectedTab: any

  @Output() tabChange = new EventEmitter()
  @Input() transparent = false

  ngAfterContentChecked() {
    const activeTab = this.tabs.find((tab) => tab.active)
    if (!!activeTab && this.selectedTab !== activeTab.id) {
      this.selectedTab = activeTab.id
    }
  }
}
